module.exports = __webpack_public_path__ + "media/components/country-flag/static/pe-277995bd4046af4625ed84f9e0c7e141.svg";